import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isClubRole } from 'app/common/models/user-info.model';
import { IRoutingParams } from 'app/common/models/context.model';
import { ApiV2Service } from 'app/common/services/api-v2.service';
import { PersistenceService } from 'app/common/services/persistence.service';
import { AuthService } from 'app/common/services/auth.service';
import { IToken } from 'app/common/models/token.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ILoginData } from 'app/common/models/login-data.model';

@Component({
  selector: 'app-accesses',
  templateUrl: './accesses.component.html',
  styleUrls: ['./accesses.component.scss']
})
export class AccessesComponent implements OnInit {
  public context: IRoutingParams;
  public form: FormGroup;
  public isSubmitting = false;
  public loginData: ILoginData = {} as ILoginData;

      constructor(
        private router: Router,
        private authService: AuthService,
        private persistenceService: PersistenceService,
        private formBuilder: FormBuilder,
        private apiv2: ApiV2Service,
      ) {
      }
    

      ngOnInit(): void {
        this.buildForm(); 
      }
    
      buildForm() {
        
        this.form = this.formBuilder.group({
          emailOrPhone: [
            null, 
            [Validators.required, this.emailOrPhoneValidator()] 
          ]
        });
      }
      private emailOrPhoneValidator(): Validators {
        return (control) => {
          const value = control.value;
          console.log(value);
          if (!value) return null;
    
          const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          
          const isPhone = /^(\+7|8)\d{10,15}$/.test(value.replace(/\D/g, ''));
    
          return isEmail || isPhone ? null : { invalidFormat: true };
        };
      }
      private normalizePhone(phone: string): string {
        return phone.replace(/^8/, '+7').replace(/\D/g, '');
      }

      async send(event: Event): Promise<void>{
        event.preventDefault();
        if (this.form.invalid || this.isSubmitting) return;

        this.isSubmitting = true;
        const credentials = this.form.value.emailOrPhone;
    
        try {
          const isEmail = credentials.includes('@');
          const payload = isEmail 
            ? credentials 
            : this.normalizePhone(credentials);
          this.loginData.emailOrPhone = payload; 
          await this.apiv2.accounting.sudoLogin(this.loginData)    
          .then(async (res) => {
            await this.writeToken(res);
            await this.redirectAfterLogin();
          });
          }
          catch {
          } 
          finally {
            this.isSubmitting = false;
          }

      }
      private async writeToken(token: IToken) {
          window.localStorage.setItem('Token', JSON.stringify(token));
          window.localStorage.removeItem('userInfo') 
      }
      public async redirectAfterLogin() {
        
        if (this.authService.isLoggedIn) {
          const userInfo = await this.authService.getUserInfo();
    
          if (isClubRole(userInfo)) {
            if (!this.persistenceService.checkSheduledRedirect()) {
              const ctx = await this.apiv2.context.get();
              const firstClub = ctx.clubs.find(x => x.cityId !== '00000000000000000000000000000000' && x.cityId !== '00000000-0000-0000-0000-000000000000');
              if (firstClub) {
                this.router.navigate([`/home`]);
              } else {
                this.authService.logout();
              }
            }
          } else {
            if (!this.persistenceService.checkSheduledRedirect()) {
              this.router.navigate([`/`]);
            }
          }
        }
      }
}
